import { AxiosError } from 'axios';

export class RequestCancelError extends Error {
  error: unknown;
  constructor(error: unknown) {
    super('RequestCancelError');
    this.error = error;
  }
}

export class UnexpectedError extends Error {
  error: unknown;
  constructor(error: unknown) {
    super('UnexpectedError');
    this.error = error;
  }
}

export class UnauthorizedError extends Error {
  error: unknown;
  constructor(error: unknown) {
    super('UnauthorizedError');
    this.error = error;
  }
}

export class APIError extends Error {
  code: number;
  originError: AxiosError<any>;
  constructor(code: number, error: AxiosError<any>) {
    super('APIError');
    this.code = code;
    this.originError = error;
  }
}
